import { Col, Form, Input, message, Row, Select, Upload } from "antd";
import { useEffect, useState } from "react";
import { formatSizeBytes } from "../../common/helpers";
import { GetCountries } from "../../API/endpoints/Common";

interface Props {
  businessInfoForm: any;
  selectedCompanyOverview: any;
  setSelectedCompanyOverview: any;
  selectedClientPortfolio: any;
  setSelectedClientPortfolio: any;
  selectedDraftAgreement: any;
  setSelectedDraftAgreement: any;
  selectedFiles: any;
  setSelectedFiles: any;
  setMandatoyFiles: any;
  mandatoyFiles: any;
  editPartnerData: any;
}

const BusinessInfo = (props: Props) => {
  const {
    businessInfoForm,
    selectedCompanyOverview,
    setSelectedCompanyOverview,
    selectedClientPortfolio,
    setSelectedClientPortfolio,
    selectedDraftAgreement,
    setSelectedDraftAgreement,
    selectedFiles,
    setSelectedFiles,
    setMandatoyFiles,
    mandatoyFiles,
    editPartnerData,
  } = props;
  const { Option } = Select;

  const [countriesList, setCountriesList] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      const getAllCountries = await GetCountries();
      setCountriesList(getAllCountries?.data);
    };
    fetchAll();
  }, []);

  const onChangeFileOverview = (e: any) => {
    if (e?.file) {
      const file = e.file;
      const allowedTypes = [
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
      ];

      const maxFileSize = 10 * 1024 * 1024; // 10MB

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid document file. Only .doc, .docx, and .pdf are allowed.`);
        return;
      }

      // Validate file size
      if (file.size > maxFileSize) {
        message.error(`${file.name} size exceeds the limit of 10MB`);
        console.error("File size exceeds the limit of 10MB");
        return;
      }

      const data = new FormData();
      data.append("file", file);
      // data.append("partner_id", partnerID ?? "");
      data.append("field", "company_overview");
      setMandatoyFiles({ ...mandatoyFiles, company_overview: data });


      if (e?.file?.status && e?.file?.status === "removed") {
        setSelectedCompanyOverview((prev: any) =>
          prev.filter((item: any) => item.uid !== e?.file?.uid)
        );
      } else {
        setSelectedCompanyOverview((prev: any) => [e?.file, ...prev]);
      }
    } else {
      setSelectedCompanyOverview([]);
    }
  };

  const onChangeClientPortfolio = (e: any) => {
    if (e?.file) {
      const file = e.file;

      const allowedTypes = [
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
      ];

      const maxFileSize = 10 * 1024 * 1024; // 10MB

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid document file. Only .doc, .docx, and .pdf are allowed.`);
        return;
      }

      // Validate file size
      if (file.size > maxFileSize) {
        message.error(`${file.name} size exceeds the limit of 10MB`);
        console.error("File size exceeds the limit of 10MB");
        return;
      }

      const data = new FormData();
      data.append("file", file);
      // data.append("partner_id", partnerID ?? "");
      data.append("field", "client_portfolio");
      setMandatoyFiles({ ...mandatoyFiles, client_portfolio: data });

      if (e?.file?.status && e?.file?.status === "removed") {
        setSelectedClientPortfolio((prev: any) =>
          prev.filter((item: any) => item.uid !== e?.file?.uid)
        );
      } else {
        setSelectedClientPortfolio((prev: any) => [e?.file, ...prev]);
      }
    } else {
      setSelectedClientPortfolio([]);
    }
  };

  const onChangeDraftAgreement = (e: any) => {
    if (e?.file) {
      const file = e.file;

      const allowedTypes = [
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
      ];

      const maxFileSize = 10 * 1024 * 1024; // 10MB

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid document file. Only .doc, .docx, and .pdf are allowed.`);
        return;
      }

      // Validate file size
      if (file.size > maxFileSize) {
        message.error(`${file.name} size exceeds the limit of 10MB`);
        console.error("File size exceeds the limit of 10MB");
        return;
      }

      const data = new FormData();
      data.append("file", file);
      // data.append("partner_id", partnerID ?? "");
      data.append("field", "draft_agreements");
      setMandatoyFiles({ ...mandatoyFiles, draft_agreements: data });
  

      if (e?.file?.status && e?.file?.status === "removed") {
        setSelectedDraftAgreement((prev: any) =>
          prev.filter((item: any) => item.uid !== e?.file?.uid)
        );
      } else {
        setSelectedDraftAgreement((prev: any) => [e?.file, ...prev]);
      }
    } else {
      setSelectedDraftAgreement([]);
    }
  };

  const onChangeFile = (e: any) => {
    if (e?.file) {
      const file = e.file;
      const allowedTypes = [
        'application/pdf',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
      ];

      const maxFileSize = 10 * 1024 * 1024; // 10MB

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid document file. Only .doc, .docx, and .pdf are allowed.`);
        return;
      }

      // Validate file size
      if (file.size > maxFileSize) {
        message.error(`${file.name} size exceeds the limit of 10MB`);
        console.error("File size exceeds the limit of 10MB");
        return;
      }

      const data = new FormData();
      data.append("file", file);
      data.append("file_name", file.name);
      data.append("service", "1");
      setMandatoyFiles({ ...mandatoyFiles, additionalUploads: data });
   

      if (e?.file?.status && e?.file?.status === "removed") {
        setSelectedFiles((prev: any) =>
          prev.filter((item: any) => item.uid !== e?.file?.uid)
        );
      } else {
        setSelectedFiles((prev: any) => [e?.file, ...prev]);
      }
    } else {
      setSelectedFiles([]);
    }
  };

  const removeFile = (file: any) => {
    setSelectedFiles([]);
    if (editPartnerData?.additionalDocs) {
      editPartnerData.additionalDocs = "";
    }
  };

  const removeFileOverview = (file: any) => {
    setSelectedCompanyOverview([]);
    if (editPartnerData?.company_overview) {
      editPartnerData.company_overview = "";
    }
  };

  const removeClientPortfolio = (file: any) => {
    setSelectedClientPortfolio([]);
    if (editPartnerData?.client_portfolio) {
      editPartnerData.client_portfolio = "";
    }
  };

  const removeDraftAgreement = (file: any) => {
    setSelectedDraftAgreement([]);
    if (editPartnerData?.draft_agreements) {
      editPartnerData.draft_agreements = "";
    }
  };

  const validateEmail = () => {
    const emailPattern =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return {
      validator: (_: any, value: any) =>
        emailPattern.test(value)
          ? Promise.resolve()
          : Promise.reject(new Error("Invalid Email ID")),
    };
  };

  return (
    <Form layout="vertical" form={businessInfoForm}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Company Name"
            name="name"
            rules={[{ required: true, message: "Please enter company name" }]}
          >
            <Input placeholder="Enter company name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please select the location" }]}
            label="Location"
            name="country_of_origin"
          >
            <Select placeholder="Select location">
              {countriesList.map((country: any) => (
                <Option key={country.id} value={country.id}>
                  {country.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please enter the Key Contact Person",
              },
            ]}
            label="Key Contact Person"
            name="poc_name"
          >
            <Input placeholder="John Doe" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please enter the Designation",
              },
            ]}
            label="Designation"
            name="poc_designation"
          >
            <Input placeholder="Brand Manager" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please enter the Email",
              },
              validateEmail,
            ]}
            label="Email"
            name="poc_email"
          >
            <Input
              disabled={Object.keys(editPartnerData).length > 0}
              type="email"
              placeholder="email@example.com"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please enter the Phone",
              },
            ]}
            label="Phone"
            name="poc_phone"
          >
            <Input
              addonBefore={
                <Form.Item name="poc_countrycode" noStyle>
                  <Select style={{ width: 80 }}>
                    {countriesList.map((country: any) => (
                      <Option key={country.id} value={country.country_code}>
                        {country.country_code}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              }
              placeholder="+65 1234 4567"
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            rules={[{ required: true, message: "Please enter the website" }]}
            label="Website"
            name="website"
          >
            <Input placeholder="https://example.com" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <p className="m-[0] p-[10px_0_28px] text-[#1D2939] text-[16px] font-[600] ">
            Documents
          </p>
          <Form.Item>
            <div className="flex flex-wrap gap-[16px]">
              {selectedCompanyOverview.length ||
                editPartnerData?.company_overview ? (
                (selectedCompanyOverview.length
                  ? selectedCompanyOverview
                  : [editPartnerData.company_overview]
                ).map((item: any, index: number) => {
                  const isString = typeof item === "string";
                  const fileName = isString
                    ? item.split("/").pop()
                    : item?.name || "file";

                  const extension = fileName?.split(".").pop()?.toLowerCase();

                  let fileIcon = "/svgs/pdfIcon.svg";
                  // if (["jpg", "jpeg", "png"].includes(extension || "")) {
                  //   fileIcon = "/svgs/imageIcon.svg";
                  // }

                  return (
                    <div
                      key={index}
                      className="flex justify-between items-center p-[11px_12px] border border-[#F5F5F5] rounded-[4px] basis-[48%]"
                    >
                      <div className="flex cursor-pointer items-center gap-[10px]">
                        <img
                          src={fileIcon}
                          alt="file-icon"
                          className="w-[40px] h-[40px] object-contain"
                        />
                        <div>
                          <p className="m-0 text-[12px] font-medium text-[#292929]">
                            {fileName}
                          </p>
                          <p className="m-0 text-[12px] text-[#737373]">
                            {!isString && item?.size
                              ? formatSizeBytes(item?.size)
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div
                        className="cursor-pointer"
                        onClick={() => removeFileOverview(item)}
                      >
                        <img src="/svgs/deleteIcon.svg" alt="deleteIcon" />
                      </div>
                    </div>
                  );
                })
              ) : (
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={(e) => onChangeFileOverview(e)}
                  fileList={selectedCompanyOverview}
                  showUploadList={false}
                  accept=".doc,.docx,.pdf"
                  className="basis-[48%] custom-upload"
                >
                  <div className="flex items-center gap-[10px] w-full border border-[#E4E7EC] rounded-[6px] p-[11px_12px] cursor-pointer">
                    <img src="/svgs/uploadIcon.svg" alt="uploadIcon" />
                    <div className="flex flex-col gap-[4px]">
                      <p className="m-0 text-[13px] font-[400]">
                        Upload{" "}
                        <span className="font-[500]">Company Overview</span>
                      </p>
                    </div>
                  </div>
                </Upload>
              )}
              {selectedClientPortfolio.length ||
                editPartnerData?.client_portfolio ? (
                (selectedClientPortfolio.length
                  ? selectedClientPortfolio
                  : [editPartnerData.client_portfolio]
                ).map((item: any, index: number) => {
                  const isString = typeof item === "string";
                  const fileName = isString
                    ? item.split("/").pop()
                    : item?.name || "file";

                  const extension = fileName?.split(".").pop()?.toLowerCase();
                  let fileIcon = "/svgs/pdfIcon.svg";
                  // if (["jpg", "jpeg", "png"].includes(extension || "")) {
                  //   fileIcon = "/svgs/imageIcon.svg";
                  // }

                  return (
                    <div
                      key={index}
                      className="flex justify-between items-center p-[11px_12px] border border-[#F5F5F5] rounded-[4px] basis-[48%]"
                    >
                      <div className="flex cursor-pointer items-center gap-[10px]">
                        <img
                          src={fileIcon}
                          alt="file-icon"
                          className="w-[40px] h-[40px] object-contain"
                        />
                        <div>
                          <p className="m-0 text-[12px] font-medium text-[#292929]">
                            {fileName}
                          </p>
                          <p className="m-0 text-[12px] text-[#737373]">
                            {!isString && item?.size
                              ? formatSizeBytes(item?.size)
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div
                        className="cursor-pointer"
                        onClick={() => removeClientPortfolio(item)}
                      >
                        <img src="/svgs/deleteIcon.svg" alt="deleteIcon" />
                      </div>
                    </div>
                  );
                })
              ) : (
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={(e) => onChangeClientPortfolio(e)}
                  fileList={selectedClientPortfolio}
                  showUploadList={false}
                  accept=".doc,.docx,.pdf"
                  className="basis-[48%] custom-upload"
                >
                  <div className="flex items-center gap-[10px] basis-[48%] border border-[#E4E7EC] rounded-[6px] p-[11px_12px] cursor-pointer">
                    <img src="/svgs/uploadIcon.svg" alt="uploadIcon" />
                    <div className="flex flex-col gap-[4px]">
                      <p className="m-0 text-[13px] font-[400]">
                        Upload{" "}
                        <span className="font-[500]">Client Portfolio</span>
                      </p>
                    </div>
                  </div>
                </Upload>
              )}
              {selectedDraftAgreement.length ||
                editPartnerData?.draft_agreements ? (
                (selectedDraftAgreement.length
                  ? selectedDraftAgreement
                  : [editPartnerData.draft_agreements]
                ).map((item: any, index: number) => {
                  const isString = typeof item === "string";
                  const fileName = isString
                    ? item.split("/").pop()
                    : item?.name || "file";

                  const extension = fileName?.split(".").pop()?.toLowerCase();
                  let fileIcon = "/svgs/pdfIcon.svg";
                  // if (["jpg", "jpeg", "png"].includes(extension || "")) {
                  //   fileIcon = "/svgs/imageIcon.svg";
                  // }

                  return (
                    <div
                      key={index}
                      className="flex justify-between items-center p-[11px_12px] border border-[#F5F5F5] rounded-[4px] basis-[48%]"
                    >
                      <div className="flex cursor-pointer items-center gap-[10px]">
                        <img
                          src={fileIcon}
                          alt="file-icon"
                          className="w-[40px] h-[40px] object-contain"
                        />
                        <div>
                          <p className="m-0 text-[12px] font-medium text-[#292929]">
                            {fileName}
                          </p>
                          <p className="m-0 text-[12px] text-[#737373]">
                            {!isString && item?.size
                              ? formatSizeBytes(item?.size)
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div
                        className="cursor-pointer"
                        onClick={() => removeDraftAgreement(item)}
                      >
                        <img src="/svgs/deleteIcon.svg" alt="deleteIcon" />
                      </div>
                    </div>
                  );
                })
              ) : (
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={(e) => onChangeDraftAgreement(e)}
                  fileList={selectedDraftAgreement}
                  showUploadList={false}
                  accept=".doc,.docx,.pdf"
                  className="basis-[48%] custom-upload"
                >
                  <div className="flex items-center gap-[10px] basis-[48%] border border-[#E4E7EC] rounded-[6px] p-[11px_12px] cursor-pointer">
                    <img src="/svgs/uploadIcon.svg" alt="uploadIcon" />
                    <div className="flex flex-col gap-[4px]">
                      <p className="m-0 text-[13px] font-[400]">
                        Upload{" "}
                        <span className="font-[500]">Draft Agreement</span>
                      </p>
                    </div>
                  </div>
                </Upload>
              )}
              {selectedFiles?.length || editPartnerData?.additionalDocs ? (
                (selectedFiles.length
                  ? selectedFiles
                  : editPartnerData?.additionalDocs
                ).map((item: any, index: number) => {
                  const isString = typeof item === "string";
                  const fileName = isString
                    ? item.split("/").pop()
                    : item?.name || "file";

                  const extension = fileName?.split(".").pop()?.toLowerCase();
                  let fileIcon = "/svgs/pdfIcon.svg";

                  return (
                    <div
                      key={index}
                      className="flex basis-[48%] justify-between items-center p-[16px] border-[1px] border-solid border-[#F5F5F5] rounded-[4px]"
                    >
                      <div className="flex gap-[10px] cursor-pointer items-center">
                        <img
                          src={fileIcon}
                          alt="file-icon"
                          className="w-[40px] h-[40px] object-contain"
                        />
                        <div>
                          <p className="m-[0] text-[12px] font-medium text-[#292929]">
                            {fileName}
                          </p>
                          <p className="m-[0] text-[12px] text-[#737373]">
                            {!isString && item?.size
                              ? formatSizeBytes(item?.size)
                              : ""}
                          </p>
                        </div>
                      </div>

                      <div
                        className="cursor-pointer"
                        onClick={() => removeFile(item)}
                      >
                        <img src="/svgs/deleteIcon.svg" alt="deleteIcon" />
                      </div>
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
            {!selectedFiles.length && !editPartnerData?.additionalDocs && (
              <Upload
                multiple
                beforeUpload={() => false}
                onChange={(e) => onChangeFile(e)}
                fileList={selectedFiles}
                showUploadList={false}
                accept=".doc,.docx,.pdf"
              >
                <p className="cursor-pointer p-[16px] !border-none !text-[#667085] !text-[14px]">
                  Upload Documents
                </p>
              </Upload>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default BusinessInfo;
